<template>
  <confirm-dialog
    :show="show"
    :message="message"
    @accept="changeStatus"
    @close="$emit('close')">
  </confirm-dialog>
</template>
 
<script>
import ConfirmDialog from '@/components/global/ConfirmDialog';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    botTemplate: {
      type: Object,
      required: true,
    },
  },
  components: {
    ConfirmDialog,
  },
  computed: {
    message() {
      return `¿Esta seguro de que desea ${this.botTemplate.status === 'Activo' ? 'desactivar' : 'activar'} la plantilla ${this.botTemplate.name}?.`;
    },
  },
  methods: {
    changeStatus() {
      this.axios.patch(`bot_templates/${this.botTemplate.id}`, {
        status: this.botTemplate.status === 'Activo' ? 'Inactivo' : 'Activo',
      }).then((response) => {
        this.$emit('updated', response.data);
        this.$emit('close');
      }).catch(() => {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/bot_v4/ChangeStatus.vue